import React from "react";
// import { bool, func, shape } from "prop-types";
import { bool, shape } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { statusTagColor } from "util/creditBills";
import Button from "pages/_components/Button";
import FormattedAmount from "pages/_components/FormattedAmount";
import InfoTag from "pages/echeck/components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import { useDispatch } from "react-redux";
import { actions as creditBillActions } from "reducers/creditBills";

const ItemRow = ({ data, showButton, isDesktop }) => {
    const dispatch = useDispatch();
    const handleDeleteItem = () => {
        dispatch(creditBillActions.setBillList(data.facturaId.numeroComprobante));
    };
    return (
        <>
            <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
                {isDesktop ? (
                    <CustomText text={`${data?.facturaId?.cuitEmisor} \n ${data?.razonSocialEmisor}`} />
                ) : (
                    <CustomData
                        titleText="creditBill.table.debtor"
                        titleTextType="I18N"
                        valueText={`${data?.facturaId?.cuitEmisor} \n ${data?.razonSocialEmisor}`}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} rowWidth={1}>
                {isDesktop ? (
                    <CustomText text={`${data?.cuitComprador} \n ${data?.razonSocialComprador}`} />
                ) : (
                    <CustomData
                        titleText="creditBill.table.holder"
                        titleTextType="I18N"
                        valueText={`${data?.cuitComprador} \n ${data?.razonSocialComprador}`}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3} rowWidth={1}>
                {isDesktop ? (
                    <FormattedDate date={data?.fechaEmision} dateFormat="DD/MM/YYYY" />
                ) : (
                    <CustomData
                        titleText="creditBill.table.emission"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={data?.fechaEmision} dateFormat="DD/MM/YYYY" />}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 4 : 1} rowStart={isDesktop ? 1 : 4} rowWidth={1}>
                {isDesktop ? (
                    <FormattedDate date={data?.fechaVencimientoPago} dateFormat="DD/MM/YYYY" />
                ) : (
                    <CustomData
                        titleText="creditBill.table.expiration"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={data?.fechaVencimientoPago} dateFormat="DD/MM/YYYY" />}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 5 : 1} rowStart={isDesktop ? 1 : 5} rowWidth={1}>
                {isDesktop ? (
                    <FormattedAmount currency={data?.moneda} quantity={data?.saldoAceptado} />
                ) : (
                    <CustomData
                        titleText="creditBill.table.amount"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={data?.moneda} quantity={data?.saldoAceptado} />}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 6 : 2} rowStart={1} rowWidth={1} className="info-tag-credit-bill">
                <InfoTag type="info" message={data?.estadoFactura} tagBackground={statusTagColor(data.estadoFactura)} />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 7 : 1} rowStart={isDesktop ? 1 : 6} rowWidth={1}>
                {isDesktop ? (
                    <CustomText
                        text={`${data?.cbuCredito?.substring(0, 10)}\n${data?.cbuCredito?.substring(10)}`}
                        textType="TEXT"
                    />
                ) : (
                    <CustomData
                        titleText="creditBill.table.registeredCbu"
                        titleTextType="I18N"
                        valueText={`${data?.cbuCredito}`}
                    />
                )}
            </GridTable.Data>

            {showButton && (
                <GridTable.Data columnStart={isDesktop ? 8 : 2} rowStart={isDesktop ? 1 : 6} rowWidth={1}>
                    <Button bsStyle="link" onClick={handleDeleteItem} image="images/trash.svg" />
                </GridTable.Data>
            )}
        </>
    );
};

ItemRow.propTypes = {
    data: shape(echeqPropTypes).isRequired,
    showButton: bool,
    isDesktop: bool.isRequired,
};
ItemRow.defaultProps = {
    showButton: false,
};

export default ItemRow;
